import { render, staticRenderFns } from "./ComplaintsReport.vue?vue&type=template&id=3a88f5ec"
import script from "./ComplaintsReport.vue?vue&type=script&lang=js"
export * from "./ComplaintsReport.vue?vue&type=script&lang=js"
import style0 from "./ComplaintsReport.vue?vue&type=style&index=0&id=3a88f5ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports